import { render, staticRenderFns } from "./ItsStockFruitOutBound.vue?vue&type=template&id=3c5b0c11&scoped=true&"
import script from "./ItsStockFruitOutBound.vue?vue&type=script&lang=js&"
export * from "./ItsStockFruitOutBound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5b0c11",
  null
  
)

export default component.exports